import { useAxios } from "../../../../../hooks/useAxios"
import { misActividadesProfesionalesAdapters } from "../adapters/actividadesProfesionales.adapter"

var misActividadesProfesionalesServices = {

    GET: () => {

        return useAxios({ 
            method: 'get', url: '/personas/actividades-profesionales-current-user/listar?limit=200', 
            type: 'json', adapters: misActividadesProfesionalesAdapters.GET 
        })
    },

    POST: () => {

        return useAxios({ 
            method: 'post', url: '/personas/actividades-profesionales-current-user/crear', 
            type: 'json', adapters: misActividadesProfesionalesAdapters.POST 
        })
    },

    PATCH: () => {

        return useAxios({ 
            method: 'patch', url: '/personas/actividades-profesionales-current-user', 
            type: 'json', adapters: misActividadesProfesionalesAdapters.PATCH 
        })
    },

    DELETE: () => {

        return useAxios({ 
            method: 'delete', url: '/personas/actividades-profesionales-current-user', 
            type: 'json', adapters: misActividadesProfesionalesAdapters.DELETE 
        })
    }
}

export {
    misActividadesProfesionalesServices
}